<template>
  <div>
    <b-card
      title="Input Groups with Buttons"
      no-body
      class="mb-0 pt-2 pl-2 pr-2"
    >
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="4"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Mostrando</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="pageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>registros</label>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="8"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="query"
                class="d-inline-block mr-1"
                placeholder="Buscar..."
              />
              <!-- <v-select
                v-model="statusFilter"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="descripcion"
                :options="statusOptions"
                class="invoice-filter-select d-inline-block mr-1"
                placeholder="Filtros Ose"
                @input="chageStatusFilter"
            /> -->
              <b-button
                variant="primary"
                @click="openForm('new')"
              >
                <span class="text-nowrap">Nuevo</span>
              </b-button>
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
        ref="refUserListTable"
        class="position-relative"
        :items="items"
        responsive
        :fields="fields"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No se encontraron registros"
        :busy="isBusy"
      >
        <template #table-busy>
          <div class="text-center text-primary my-2">
            <b-spinner
              variant="primary"
              class="align-middle"
            />
            <strong class="ml-1">Cargando...</strong>
          </div>
        </template>
        <template #cell(totalCuadre)="data">
          {{ parseFloat(data.item.totalCuadre).toFixed(2) }}
        </template>
        <template #cell(totalEfectivo)="data">
          {{ parseFloat(data.item.totalEfectivo).toFixed(2) }}
        </template>
        <template #cell(totalCobro)="data">
          {{ parseFloat(data.item.totalCobro).toFixed(2) }}
        </template>
        <template #cell(totalFise)="data">
          {{ parseFloat(data.item.totalFise).toFixed(2) }}
        </template>
        <template #cell(totalGasto)="data">
          {{ parseFloat(data.item.totalGasto).toFixed(2) }}
        </template>

        <template #cell(responsable)="data">
          <div class="d-flex align-items-center">
            <div
              v-if="data.item.vendedor !== null"
            >
              <div class="font-small-3 font-weight-bolder">
                {{ data.item.vendedor.trabajador.nombreCompleto }}
              </div>
              <div class="font-small-2 text-muted">
                DNI: {{ data.item.vendedor.trabajador.documento }} -  {{ data.item.vendedor.trabajador.cargo }}
              </div>
            </div>
            <div
              v-if="data.item.salida !== null"
            >
              <div class="font-small-3 font-weight-bolder">
                {{ data.item.salida.conductor.nombreCompleto }}
              </div>
              <div class="font-small-2 text-muted">
                SALIDA: {{ data.item.salida.codigo }}
              </div>
            </div>
          </div>
        </template>
        <!-- Column: Actions -->
        <template #cell(acciones)="data">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >

            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item
              target="_blank"
              @click="getPrintPdf(data)"
            >
              <feather-icon icon="PrinterIcon" />
              <span class="align-middle ml-50">Ver Cuadre</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Mostrando {{ from }} a {{ to }} de {{ of }} registros</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="page"
              :total-rows="totalItems"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>

import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BDropdown, BDropdownItem, BPagination, BSpinner, VBTooltip,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { jsPDF as JsPDF } from 'jspdf'
import store from '@/store'
import { showToast, showError } from '@/helpers'
import { avatarText } from '@core/utils/filter'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    // BBadge,

    vSelect,
    BSpinner,
    // BAvatar,
    // BMedia,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },

  data: () => ({
    isBusy: false,
    idEmpresa: 3,
    isToggleSidebar: false,
    dataEdit: {},
    formType: '',
    page: 1,
    perPage: 10,
    totalRows: 0,
    totalItems: 0,
    totalPage: 0,
    from: 0,
    to: 0,
    of: 0,
    pageOptions: [10, 20, 50],
    sortBy: null,
    sortDesc: false,
    sortDirection: 'asc',
    query: '',
    items: [],
    statusFilter: { id: '-1', descripcion: 'Todos' },
    fields: [
      { key: 'liquidacionId', sortable: true, thClass: 'd-none', tdClass: 'd-none' },
      { key: 'fecha', label: 'Fecha', sortable: true },
      { key: 'responsable', label: 'Responsable', sortable: true, tdClass: 'w180', thClass: 'w180' },
      // { key: 'nroComprobante', label: 'Nro Comprobante' },
      { key: 'totalCuadre', label: 'T.Cuadre', sortable: true },
      { key: 'totalEfectivo', label: 'T.Efectivo' },
      { key: 'totalCobro', label: 'T.Cobranza' },
      { key: 'totalFise', label: 'T.Fise' },
      { key: 'totalGasto', label: 'T.Gasto' },
      { key: 'acciones' },
    ],
  }),
  watch: {
    perPage: {
      handler() {
        this.listarRegistros()
      },
    },
    page: {
      handler() {
        this.listarRegistros()
      },
    },
    query: {
      handler() {
        this.listarRegistros()
      },
    },
  },
  mounted() {
    this.listarRegistros()
  },
  methods: {
    getCuerpoCuadre(cuadre, data) {
      const row = data.item
      console.info(cuadre, row)
      const doc = new JsPDF('l', 'pt', 'a4', true)
      //  `${row.codigo}`
      doc.setProperties({
        title: 'LOQUIDACION N°',
        author: 'UNIGAS',
        creator: 'UNIGAS',
      })

      // const totalPagesExp = '{total_pages_count_string}'
      const img = row.logo
      const usuarioCrea = row.vendedor !== null ? row.vendedor.trabajador.nombreCompleto : row.salida.codigo
      doc.setFont('arial')
      doc.addImage(img, 'JPEG', 20, 7, 140, 60)
      doc.setFontSize(12)
      doc.text('UNIVERSAL GAS', 170, 20)
      doc.setFontSize(8)
      doc.text('Telef. 042-526544 Cel. 970089487', 170, 32)
      doc.text('DIRECCION: JR. FRANCISCO PIZARRO NRO. 860', 170, 43)
      doc.text('RUC: 20362013802', 170, 53)

      doc.setFontSize(12)
      doc.text(`LIQUIDACION: ${row.fecha}`, 20, 80)
      doc.setFontSize(9)
      doc.text(`RESPONSABLE: ${usuarioCrea}`, 320, 80)
      // doc.text(`PEDIDO COMPRA N°: ${row.pedido.codigo}`, 20, 100)
      // doc.text(`PROVEEDOR: ${row.proveedor.razonSocial} - ${row.proveedor.ruc}`, 180, 100)
      // doc.text(`F. REGISTRO: ${row.fechaRegistro}`, 20, 120)
      // doc.text(`F. RESPUESTA: ${row.fechaRespuesta == null ? '' : row.fechaRespuesta}`, 180, 120)
      // doc.text(` ETAPA: ${row.etapa}`, 320, 120)
      doc.setFontSize(11)
      doc.text('RESUMEN DE FORMAS DE PAGO', 10, 120)
      doc.setFontSize(9)
      doc.text('----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------', 5, 130)
      doc.text('CLIENTE', 10, 140)
      doc.text('PROD', 210, 140)
      doc.text('CANT', 250, 140)
      doc.text('EFECT', 290, 140)
      doc.text('VISA', 335, 140)
      doc.text('PLIN', 380, 140)
      doc.text('YAPE', 420, 140)
      doc.text('TRANSF', 465, 140)
      doc.text('FISE', 520, 140)
      doc.text('TOTAL', 555, 140)

      doc.text('CLIENTE', 10, 140)
      doc.text('PROD', 210, 140)
      doc.text('CANT', 250, 140)
      doc.text('EFECT', 290, 140)
      doc.text('VISA', 335, 140)
      doc.text('PLIN', 380, 140)
      doc.text('YAPE', 420, 140)
      doc.text('TRANSF.', 465, 140)
      doc.text('FISE', 520, 140)
      doc.text('TOTAL', 555, 140)
      doc.text('----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------', 5, 150)
      let initr = 160
      const { ventaCliente } = cuadre
      let totalEfectivo = 0
      let totalVisa = 0
      let totalPlin = 0
      let totalYape = 0
      let totalTranferencia = 0
      let totalFise = 0
      let totalAll = 0
      for (let i = 0; i < ventaCliente.length; i += 1) {
        const partCliente = (ventaCliente[i].cliente).split('|')
        const name = partCliente[0]
        doc.setFontSize(7.5)
        doc.text(name, 10, initr)
        doc.setFontSize(8.5)
        let productoName = ventaCliente[i].productos
        if (name === 'CLIENTE VARIOS') {
          productoName = `${(ventaCliente[i].productos).substring(0, 3)}..`
        }

        let cantidadName = ventaCliente[i].cantidades
        if (name === 'CLIENTE VARIOS') {
          cantidadName = `${(ventaCliente[i].cantidades).substring(0, 4)}..`
        }
        doc.text(productoName, 207, initr)
        doc.text(cantidadName, 247, initr)
        doc.text(`${parseFloat(ventaCliente[i].efectivo).toFixed(2)}`, 290, initr)
        doc.text(`${parseFloat(ventaCliente[i].visa).toFixed(2)}`, 335, initr)
        doc.text(`${parseFloat(ventaCliente[i].plin).toFixed(2)}`, 380, initr)
        doc.text(`${parseFloat(ventaCliente[i].yape).toFixed(2)} `, 425, initr)
        doc.text(`${parseFloat(ventaCliente[i].tranferencia).toFixed(2)}`, 468, initr)
        doc.text(`${parseFloat(ventaCliente[i].fise).toFixed(2)}`, 525, initr)
        doc.text(`${parseFloat(ventaCliente[i].total).toFixed(2)} `, 560, initr)
        initr = Number(initr) + 13
        totalEfectivo += Number(ventaCliente[i].efectivo)
        totalVisa += Number(ventaCliente[i].visa)
        totalPlin += Number(ventaCliente[i].plin)
        totalYape += Number(ventaCliente[i].yape)
        totalTranferencia += Number(ventaCliente[i].tranferencia)
        totalFise += Number(ventaCliente[i].fise)
        totalAll += Number(ventaCliente[i].total)
        if (initr + 13 >= 813) {
          doc.addPage()
          initr = 35
        }
      }
      doc.setFontSize(8)
      initr = Number(initr) + 10
      doc.text(parseFloat(totalEfectivo).toFixed(2), 290, initr)
      doc.text(parseFloat(totalVisa).toFixed(2), 335, initr)
      doc.text(parseFloat(totalPlin).toFixed(2), 380, initr)
      doc.text(parseFloat(totalYape).toFixed(2), 425, initr)
      doc.text(parseFloat(totalTranferencia).toFixed(2), 468, initr)
      doc.text(parseFloat(totalFise).toFixed(2), 525, initr)
      doc.text(parseFloat(totalAll).toFixed(2), 560, initr)

      doc.text(parseFloat(totalEfectivo).toFixed(2), 290, initr)
      doc.text(parseFloat(totalVisa).toFixed(2), 335, initr)
      doc.text(parseFloat(totalPlin).toFixed(2), 380, initr)
      doc.text(parseFloat(totalYape).toFixed(2), 425, initr)
      doc.text(parseFloat(totalTranferencia).toFixed(2), 468, initr)
      doc.text(parseFloat(totalFise).toFixed(2), 525, initr)
      doc.text(parseFloat(totalAll).toFixed(2), 560, initr)
      if (initr + 13 >= 813) {
        doc.addPage()
        initr = 35
      }
      doc.setFontSize(11)
      doc.text('RESUMEN DE PRODUCTOS', 10, initr + 20)
      doc.setFontSize(9)
      initr += 30
      doc.setFontSize(9)
      doc.text('----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------', 5, initr)
      doc.text('CLIENTE', 10, initr + 7)
      doc.text('PRODUCTOS', 235, initr + 7)
      doc.text('PRECIO', 300, initr + 7)
      doc.text('CANTIDAD', 375, initr + 7)

      doc.text('CLIENTE', 10, initr + 7)
      doc.text('PRODUCTOS', 235, initr + 7)
      doc.text('PRECIO', 300, initr + 7)
      doc.text('CANTIDAD', 375, initr + 7)
      doc.text('----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------', 5, initr + 15)
      initr += 22
      const { ventaDetalleProductoCliente } = cuadre
      for (let i = 0; i < ventaDetalleProductoCliente.length; i += 1) {
        const partCliente = (ventaDetalleProductoCliente[i].cliente).split('|')
        const name = partCliente[0]
        doc.setFontSize(7.5)
        doc.text(name, 10, initr)
        doc.setFontSize(8.5)
        doc.text(`${(ventaDetalleProductoCliente[i].productos)}`, 235, initr)
        doc.text(`${parseFloat(ventaDetalleProductoCliente[i].precio).toFixed(2)}`, 300, initr)
        doc.text(`${parseFloat(ventaDetalleProductoCliente[i].cantidades).toFixed(2)}`, 375, initr)
        initr = Number(initr) + 13
        if (initr + 13 >= 813) {
          doc.addPage()
          initr = 35
        }
      }
      if (initr + 13 >= 813) {
        doc.addPage()
        initr = 35
      }
      doc.setFontSize(11)
      doc.text('RESUMEN POR PRESENTACION', 10, initr + 20)
      doc.setFontSize(9)
      initr += 30
      doc.setFontSize(9)
      doc.text('----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------', 5, initr)
      doc.text('PRESENTACION', 10, initr + 7)
      doc.text('CANTIDADES', 235, initr + 7)
      doc.text('PRECIO', 300, initr + 7)

      doc.text('PRESENTACION', 10, initr + 7)
      doc.text('CANTIDADES', 235, initr + 7)
      doc.text('PRECIO', 300, initr + 7)
      doc.text('----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------', 5, initr + 15)
      initr += 22
      const { ventaPresentacion } = cuadre
      for (let i = 0; i < ventaPresentacion.length; i += 1) {
        const partCliente = (ventaPresentacion[i].marca).split('|')
        const name = partCliente[0]
        doc.setFontSize(7.5)
        doc.text(`${name} - ${ventaPresentacion[i].productos}`, 10, initr)
        doc.setFontSize(8.5)
        doc.text(`${(ventaPresentacion[i].cantidades)}`, 235, initr)
        doc.text(`${parseFloat(ventaPresentacion[i].precio).toFixed(2)}`, 300, initr)
        initr = Number(initr) + 13
        if (initr + 13 >= 813) {
          doc.addPage()
          initr = 35
        }
      }
      if (initr + 13 >= 813) {
        doc.addPage()
        initr = 35
      }
      // doc.text('OBSERVACION:', 20, initr)
      // doc.text(`${row.observacion == null ? '' : row.observacion}`, 20, initr + 13)
      doc.setFontSize(12)
      const simbolMoneda = 'S/' // row.codmoneda === 'PEN' ? 'S/' : '$/'
      doc.text(` Total Fise ${simbolMoneda} ${parseFloat(row.totalFise).toFixed(2)}  | Total Cobro ${simbolMoneda} ${parseFloat(row.totalCobro).toFixed(2)} | Total Gasto ${simbolMoneda} ${parseFloat(row.totalGasto).toFixed(2)}  |    Total Cuadre ${simbolMoneda} ${parseFloat(row.totalCuadre).toFixed(2)}`, 20, initr + 30)
      const blob = doc.output('blob')
      window.open(URL.createObjectURL(blob))
    },
    getPrintPdf(data) {
      console.log(data)
      const parteFecha = (data.item.fecha).split('/')
      const parserFecha = `${parteFecha[2]}-${parteFecha[1]}-${parteFecha[0]}`
      let parametros = null
      if (data.item.salida !== null) {
        parametros = { salidaId: data.item.salida.idCilindroSalidaRetorno, vendedorId: '-1', fecha: parserFecha }
      }
      if (data.item.vendedor !== null) {
        parametros = { salidaId: '-1', vendedorId: data.item.vendedor.idUsuario, fecha: parserFecha }
      }
      this.$swal({
        title: 'Resumen de ventas.......',
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        onOpen: async () => {
          this.$swal.showLoading()
          await store.dispatch('caja/CAJA_RESUMEN_CUADRE', parametros)
            .then(response => {
              this.getCuerpoCuadre(response, data)
            })
          this.$swal.close()
        },
      })
    },
    async listarRegistros() {
      console.log(this.userProfile)
      this.isBusy = true
      await store
        .dispatch('caja/LIQUIDACION_FIND_ALL', {
          limit: this.perPage,
          query: this.query,
          page: this.page,
          sortBy: 'liquidacionId%7CDESC',
        })
        .then(response => {
          this.items = response.items
          this.totalRows = response.totalRows
          this.totalItems = response.totalItems
          this.totalPage = response.totalPage
          this.from = this.perPage * (this.page - 1) + (this.totalRows ? 1 : 0)
          this.to = this.perPage * (this.page - 1) + this.totalRows
          this.of = this.totalItems
        })
        .catch(error => {
          this.showToast('Ha ocurrido un error', error, 'danger')
        })
      this.isBusy = false
    },
    openForm(type) {
    // this.formType = type
    // this.isToggleSidebar = true
      console.log(type)
      this.$router.push({ name: 'rt-caja-liquidacionform' })
    },
    refetchData(response) {
      let message = 'El proceso se ha ejecutado satisfactoriamente.'
      if (response.message) {
        message = response.message
      }
      this.showToast('Operación Extitosa', message, 'success')
      this.listarRegistros()
    },
    getColorAvatar() {
      const max = 7
      const min = 1
      const status = Math.floor(Math.random() * ((max + 1) - min) + min)
      if (status === 1) return 'primary'
      if (status === 2) return 'danger'
      if (status === 3) return 'secondary'
      if (status === 4) return 'warning'
      if (status === 5) return 'info'
      if (status === 6) return 'success'
      return 'primary'
    },
    chageStatusFilter() {
      console.log(this.statusFilter)
      this.listarRegistros()
    },
    avatarText,
    showToast,
    showError,
  },

}
</script>

<style lang="scss" scoped>
.per-page-selector {
    width: 90px;
}

.invoice-filter-select {
    min-width: 190px;

    ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
    }

    ::v-deep .vs__selected {
    width: 100px;
    }
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>

<style>
.w200{
    width: 350px !important;
}

</style>
